import { generateDialogParams } from '@/lib/generic.utils'
import { DataService } from '@api/index'

const SERVICE = new DataService('subscriptions')

export default {
  getAll(context) {
    return new Promise((resolve, reject) => {
      return SERVICE.get()
        .then(response => {
          context.commit('updateAll', response.data.result)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getSingle(context, params) {
    if (context.state.single && context.state.single.id !== params.id) context.commit('updateSingle', null)
    return new Promise((resolve, reject) => {
      return SERVICE.get(params)
        .then(response => {
          context.commit('updateSingle', response.data.result)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  update(context, params) {
    return SERVICE.update(params)
      .then(response => response.data.result)
      .catch(err => err)
  },
  convertSubscription(context, params) {
    let payload = { id: params.id, value: params.data }
    return new Promise(resolve => {
      return SERVICE.update(payload, 'patch').then(() => {
        context.dispatch('getSingle', { id: params.id })
        resolve()
      })
    })
  },
  getLicenses(context, params) {
    let SERVICE = new DataService(params.namespace)
    return new Promise((resolve, reject) => {
      return SERVICE.get()
        .then(response => {
          resolve(response.data.result)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getBatchEmails({ commit }, id) {
    const SERVICE = new DataService(`email-batches/${id}`)
    return SERVICE.get().then(({ data }) => commit('setBatchEmails', data))
  },
  deleteConfirmation(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.getDeleteConfirmation(params)
        .then(response => {
          context.commit(
            'updateGlobalDialogContent',
            generateDialogParams(params.dialogUid, 'deleteSingle', response.data),
            { root: true }
          )
          context.commit('updateGlobalDialogVisibility', { uid: params.dialogUid, value: true }, { root: true })
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteSingle(context, params) {
    return new Promise((resolve, reject) => {
      return SERVICE.delete(params)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getInlineEditingData(context) {
    const SERVICE = new DataService(`inline-editing/data/subscriptions/subscription-period`)
    return new Promise((resolve, reject) => {
      return SERVICE.getInlineEditingData()
        .then(response => {
          context.commit(
            'data/updateInlineEditingData',
            { namespace: 'subscriptions', value: response.data.result },
            { root: true }
          )
          resolve(response.data.result)
        })
        .catch(err => reject(err))
    })
  },
  getMetaDataColumns({ commit }) {
    const SERVICE = new DataService('meta-data-columns/subscription-period')

    return new Promise((resolve, reject) => {
      return SERVICE.get()
        .then(response => {
          commit('updateMetaDataColumns', response.data.result)
          resolve(response.data.result)
        })
        .catch(err => reject(err))
    })
  }
}
